import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    customers: [],
    chartData: [],
    summary: {
      totalCustomers: 0,
      totalPendingAmount: 0,
    },
  },
  loading: false,
  error: null,
};

const customerPendingSlice = createSlice({
  name: "CustomerPending",
  initialState,
  reducers: {
    CustomerPendingRequest(state) {
      state.loading = true;
      state.error = null;
    },
    CustomerPendingSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; 
      // payload expected in format: { business, customers, chartData, summary }
    },
    CustomerPendingFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    ResetCustomerPending(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    }
  },
});

// Export actions and reducer
export const {
  CustomerPendingRequest,
  CustomerPendingSuccess,
  CustomerPendingFailure,
  ResetCustomerPending,
} = customerPendingSlice.actions;

export default customerPendingSlice.reducer;
